<template>
    <table class="table table-responsive-md border border-gray">
        <thead>
            <tr class="bg-table-header">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Primary Phone</th>
                <th>Relationship</th>
                <th>Email</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody v-if="isLoading || isError || !hasData">
            <!-- LOADING -->
            <template v-if="isLoading">
                <tr v-for="i of loadingCount" :key="i" class="table-loading">
                    <td v-for="i of columns" :key="i">
                        <span class="shimmer-loading"></span>
                    </td>
                </tr>
            </template>
            <!-- EMPTY -->
            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                <td :colspan="columns">
                    <h3>No Contacts Found.</h3>
                </td>
            </tr>
            <!-- ERROR -->
            <tr class="table-error" v-if="!isLoading && isError">
                <td :colspan="columns">
                    <ErrorMessageHandler title="Contact list" :try-again="getContacts" />
                </td>
            </tr>
        </tbody>
        <template v-else>
            <tbody v-for="(contact, index) in contacts" :key="contact.id">
                <EmergencyContactsRow
                    :contact="contact"
                    :is-re-order-requested="isReOrderRequested"
                    :patient-primary-address="patientPrimaryAddress"
                    :columns="columns"
                    :is-palliative="isPalliative"
                    :patient-id="patientId"
                    :total-contacts="totalContacts"
                    :relationships-enum="relationshipsEnum"
                    :contact-roles-enum="contactRolesEnum"
                    :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                    :refresh-list="getContacts"
                    :move-up="moveUp"
                    :move-down="moveDown"
                    :update-contact="updateEmergencyContact"
                    :delete-emergency-contact="deleteEmergencyContact"
                    :make-contact-primary="makeEmergencyContactPrimary"
                    :referral="referral"
                    :index="index"
                    :is-editing="isEditing"
                    v-on:updateIsEditing="updateIsEditing"
                />
            </tbody>
        </template>
    </table>
</template>

<script lang="ts" src="./EmergencyContactsList.ts"></script>
